import prefixAll from 'inline-style-prefixer/static';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import './styles.less';

const propTypes = {
  onScrubberOver: PropTypes.func,
  onScrubberMove: PropTypes.func,
  onScrubberOut: PropTypes.func,
};

class PlayProgressScrubber extends Component {
  render() {
    const { controlBarExpanded, progress, slider, sliderWidth } = this.props;

    if (!controlBarExpanded || slider == null) {
      return null;
    }

    const widthOfScrubber = this.scrubber ? this.scrubber.clientWidth : 0;

    const style = prefixAll({
      transform: `translateX(${progress * sliderWidth -
        widthOfScrubber / 2}px)`,
    });

    return (
      <div
        className="video-player-play-progress-scrubber-container"
        style={style}
      >
        <span
          ref={ref => (this.scrubber = ref)}
          className="video-player-play-progress-scrubber"
          onMouseOver={this.props.onScrubberOver}
          onMouseMove={this.props.onScrubberMove}
          onMouseOut={this.props.onScrubberOut}
        />
      </div>
    );
  }
}

PlayProgressScrubber.propTypes = propTypes;

export default PlayProgressScrubber;
